import { REPORTS_REDUCER_INITIAL_STATE } from "./reducers/reportsReducer";
import { ReportsReducer } from "./types/reportTypes";
import { ROUTER_REDUCER_INITIAL_STATE } from "./reducers/routerReducer";
import { RouterState } from "connected-react-router";
import { AuthReducer } from "./types/authTypes";
import { AUTH_REDUCER_INITIAL_STATE } from "./reducers/authReducer";

export type StoreType = {
  router: RouterState;
  reports: ReportsReducer;
  auth: AuthReducer;
};

export const STORE_INITIAL_STATE = {
  router: ROUTER_REDUCER_INITIAL_STATE,
  reports: REPORTS_REDUCER_INITIAL_STATE,
  auth: AUTH_REDUCER_INITIAL_STATE,
};
